import { safeLocalStorage } from '@hooks/useStorage'

export const DEFAULT_CHART_TIMEFRAME = '1'
const CHART_TIMEFRAME_STORAGE_KEY = 'markets.chartTimeline.v1'

export const readStoredChartTimeframe = () => {
  if (typeof window === 'undefined') return DEFAULT_CHART_TIMEFRAME

  try {
    return safeLocalStorage.getItem(CHART_TIMEFRAME_STORAGE_KEY) ?? DEFAULT_CHART_TIMEFRAME
  } catch {
    return DEFAULT_CHART_TIMEFRAME
  }
}

export const writeStoredChartTimeframe = (value: string) => {
  if (typeof window === 'undefined') return

  try {
    safeLocalStorage.setItem(CHART_TIMEFRAME_STORAGE_KEY, value)
  } catch {
    console.debug('Cannot set timeframe in LocalStorage')
  }
}
const CHART_TIMEZONE_LS_KEY = 'markets.chart.timezone'
export const DEFAULT_CHART_TIMEZONE = 'Europe/London'

const getAppTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_CHART_TIMEZONE

export const readStoredChartTimezone = () => {
  if (typeof window === 'undefined') return getAppTimezone()

  const storedTimezone = safeLocalStorage.getItem(CHART_TIMEZONE_LS_KEY)

  if (storedTimezone) {
    return storedTimezone
  }

  const appTimezone = getAppTimezone()

  safeLocalStorage.setItem(CHART_TIMEZONE_LS_KEY, appTimezone)

  return appTimezone
}

export const writeStoredChartTimezone = (timezone: string) => {
  if (typeof window === 'undefined') return
  safeLocalStorage.setItem(CHART_TIMEZONE_LS_KEY, timezone)
}
